<template>
  <div v-if="show">
    <base-popup @close="$emit('close')" :media="elements">
      <template #header>
        <h3>{{ title }}</h3>
      </template>
      <template #body="{el, index}">
        <div class="sub-element-item" @click="selectElement(el)">
          <div class="sub-element-icon">
            <component v-if="el.iconSVG" :is="el.iconSVG"/>
            <img v-else-if="el.icon" :src="el.icon"/>
            <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" viewBox="0 0 20 20" fill="currentColor">
              <path d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" />
            </svg>
          </div>
          <span class="sub-element-name">{{ el.text }}</span>
        </div>
      </template>
    </base-popup>
    <NameElementPopup :show="elementSelected != null" :defaultName="elementSelected ? elementSelected.text : ''" @named="selectAction" @close="elementSelected = null"/>
  </div>
</template>

<script>
import expandeIcon from "../IconComponents/expandeIcon.vue"
import addIcon from "../IconComponents/addIcon.vue"
import arrowsIcon from "../IconComponents/arrowsIcon.vue"
import backgroundIcon from "../IconComponents/backgroundIcon.vue"
import blockchainIcon from "../IconComponents/blockchainIcon.vue"
import backIcon from "../IconComponents/backIcon.vue"
import cancelIcon from "../IconComponents/cancelIcon.vue"
import nextIcon from "../IconComponents/nextIcon.vue"
import validateIcon from "../IconComponents/validateIcon.vue"
import colorIcon from "../IconComponents/colorIcon.vue"
import compositionIcon from "../IconComponents/compositionIcon.vue"
import galleryIcon from "../IconComponents/galleryIcon.vue"
import imageCarouselIcon from "../IconComponents/imageCarouselIcon.vue"
import imageGalleryIcon from "../IconComponents/imageGalleryIcon.vue"
import optionIcon from "../IconComponents/optionIcon.vue"
import shadowIcon from "../IconComponents/shadowIcon.vue"
import textIcon from "../IconComponents/textIcon.vue"
import NameElementPopup from "./NameElementPopup.vue"
import playIcon from "../IconComponents/playIcon.vue"
import BasePopup from "./Base/BasePopup.vue"

export default {
  name: 'AddSubElementPopup',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    elements: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true,
      default: "Ajouter un bloc a la page actuel"
    }
  },
  components: {
    BasePopup,
    addIcon,
    arrowsIcon,
    backgroundIcon,
    blockchainIcon,
    backIcon,
    cancelIcon,
    nextIcon,
    validateIcon,
    colorIcon,
    compositionIcon,
    expandeIcon,
    galleryIcon,
    imageCarouselIcon,
    imageGalleryIcon,
    optionIcon,
    shadowIcon,
    textIcon,
    playIcon,
    NameElementPopup
  },
  data() {
    return {
      elementSelected: null,
    }
  },
  emits: ['close', 'select'],
  methods: {
    selectAction: function(text) {
        if (!this.elementSelected) return;
        if (text) {
            this.$emit('select', {...this.elementSelected, text: text});
        } else {
            this.$emit('select', this.elementSelected);
        }
        this.elementSelected = null;
    },
    selectElement: function(element) {
        if (!element.multipleConstructorParameter)
          this.elementSelected = element;
        else {
          this.$emit('select', element);
        }
    }
  }
}
</script>

<style scoped>
/* Styles pour le popup d'ajout d'élément */

.sub-element-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 1rem;
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0.375rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.sub-element-item:hover {
  background-color: rgba(59, 130, 246, 0.1);
  border-color: #3b82f6;
}

.sub-element-icon {
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(59, 130, 246, 0.1);
  border-radius: 0.25rem;
  margin-bottom: 0.5rem;
  color: #3b82f6;
}

.sub-element-icon > img {
  width: 50px;
  height: 50px;
}

.sub-element-name {
  font-size: 0.875rem;
  color: #e5e7eb;
  text-align: center;
  word-break: break-word;
}
</style> 